export default __webpack_public_path__ + "static/media/arrow.aadfda08a8b8d94d331278d987466731.svg";